import {SuiModalService} from '@angular-ex/semantic-ui';
import {Component, Input} from '@angular/core';

import {Article} from '../../../core/models/articles/articles.model';
import {ArticlesService} from '../../../core/services/articles/articles.service';
import {AlertModal} from '../../modals/alert-modal/alert-modal.component';

@Component({
  selector: 'app-articles-list',
  templateUrl: './articles-list.component.html',
  styleUrls: ['./articles-list.component.css'],
  standalone: false,
})
export class ArticlesListComponent {
  @Input() articles: Article[] = [];
  @Input() showDescription = true;
  @Input() showDeadlines = false;
  @Input() showLinks = false;
  @Input() showAuthor = false;
  @Input() showUpdatedAt = false;
  @Input() showActions = false;

  constructor(
    private modalService: SuiModalService,
    private articlesService: ArticlesService,
  ) {
  }

  delete(article: Article) {
    this.modalService.open(new AlertModal(
      $localize`:@@articles-delete-confirmation-title:Artikel "${article.title}" löschen?`,
      $localize`:@@articles-delete-confirmation-message:Soll dieser Artikel wirklich gelöscht werden? Dieser Vorgang kann nicht rückgängig gemacht werden!`)
    ).onApprove(() => {
      this.articlesService.deleteOne(article._id).subscribe(() => {
        this.articles.splice(this.articles.indexOf(article), 1);
      });
    });
  }
}
